import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { useRoadworksQuery } from "../../../../common/hooks/queries/useRoadworksQuery"

import { roadworksQueryKeys } from "./queryKeys"
import { useRoadworkWithTasks } from "./useRoadwork"
import { useRoadworksProject } from "./useRoadworksProjectQuery"

export function useNetworkRoadworkLayer(queryParameters, config = {}) {
    const { selectedNetwork } = useNetworksStateContext()
    const parameters = {
        ...queryParameters,
        as_geojson: true,
    }
    const { enabled = true } = config
    const queryKey = roadworksQueryKeys.layer()
    const url = "roadworks/"

    return useRoadworksQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            enabled: !!selectedNetwork && enabled,
        },
    )
}

const useRoadworkLayerQueryKey = () => {

    const { selectedNetwork } = useNetworksStateContext()
    const { data: roadworkProject } = useRoadworksProject()

    return [...roadworksQueryKeys["layer"](roadworkProject?.layer), { network: selectedNetwork.slug }]
}

export const useExistingRoadwork = (roadworkUuid, road, onError) => {
    const layerQueryKey = useRoadworkLayerQueryKey()
    const queryClient = useQueryClient()
    const { data: roadworkProject } = useRoadworksProject()

    const roadworkDataLayerCache = queryClient.getQueryData(layerQueryKey)
    const existingRoadworkInCacheFromLayer = roadworkDataLayerCache?.features ? roadworkDataLayerCache?.some(roadwork => {
        return roadwork.uuid === roadworkUuid
    }) : roadworkDataLayerCache?.features?.some(roadwork => {
        return roadwork.properties.uuid === roadworkUuid
    })

    const roadworkQueryKey = roadworksQueryKeys["roadwork"](roadworkUuid)
    const existingRoadworkInQuery = queryClient.getQueryData(roadworkQueryKey)
    const existingRoadworkInCache = !!(existingRoadworkInQuery || existingRoadworkInCacheFromLayer)
    const { isLoading, isError } = useRoadworkWithTasks(roadworkUuid, road, {
        enabled: !existingRoadworkInCache && !!roadworkProject,
        onError,
    })

    return existingRoadworkInCache || !(isLoading || isError)
}